import { Injectable } from '@angular/core';
import { fromEvent, BehaviorSubject } from 'rxjs';
import { debounceTime, map, startWith } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class ScreenResizeService {
  private screenWidthSubject = new BehaviorSubject<number>(window.innerWidth);

  screenWidth$ = this.screenWidthSubject.asObservable();

  constructor() {
    fromEvent(window, 'resize')
      .pipe(
        debounceTime(200),
        map(() => window.innerWidth),
        startWith(window.innerWidth)
      )
      .subscribe(this.screenWidthSubject);
  }
}
